import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import { TOGGLE_ACCOUNT_SIDE_MENU, TOGGLE_ACCOUNT_SIDE_MENU_ERROR_MODAL } from './actions';
import {
  Container,
  Overlay,
  Panel,
  PanelHeader,
  CloseButton,
  PanelBody,
  ProfileInfo,
  Greetings,
  Email,
  Menu,
  MenuItem,
  LogoutCTA,
  CloseIcon,
} from './css';
import { routes } from '../../../utils/constants';
import logOut from '../../Logout/actions';
import { switchDivision } from '../../../actions/accounts';
import { getSitecoreStateAuthToken } from '../../../utils/func';
import LogoutIcon from '../../../assets/icons/logout_icon.svg';
import ChevronIconOrange from '../../../assets/icons/chevron_icon_orange.svg';

const AccountSideMenu = ({
  accountSideMenu,
  userEmail,
  toggleAccountSideMenu,
  logOut,
  fullName,
}) => (
  <Container $isOpen={accountSideMenu.isOpen}>
    <Overlay onClick={() => toggleAccountSideMenu()} />
    <Panel>
      <PanelHeader>
        <CloseButton onClick={() => toggleAccountSideMenu()}>
          <CloseIcon aria-label={t('Close')} />
        </CloseButton>
      </PanelHeader>
      <PanelBody>
        <ProfileInfo>
          <Greetings>
            {t('Hello')}
            ,
            {' '}
            {fullName || userEmail}
          </Greetings>
          <Email>{userEmail}</Email>
        </ProfileInfo>
        <Menu>
          <MenuItem to={`${routes.userProfile}?tab=UserPreferences`} onClick={() => toggleAccountSideMenu()}>
            <p>{t('UserPreferences')}</p>
            <object type="image/svg+xml" data={ChevronIconOrange} aria-label={t('UserPreferences')} />
          </MenuItem>
          <MenuItem to={`${routes.userProfile}?tab=AccountPermissions`} onClick={() => toggleAccountSideMenu()}>
            <p>{t('AccountPermissions')}</p>
            <object type="image/svg+xml" data={ChevronIconOrange} aria-label={t('AccountPermissions')} />
          </MenuItem>
        </Menu>
        <LogoutCTA onClick={logOut}>
          <object type="image/svg+xml" data={LogoutIcon} aria-label={t('SignOut')} />
          <p>{t('SignOut')}</p>
        </LogoutCTA>
      </PanelBody>
    </Panel>
  </Container>
);

AccountSideMenu.propTypes = {
  accountSideMenu: PropTypes.shape({
    isOpen: PropTypes.bool,
  }),
  userEmail: PropTypes.string,
  toggleAccountSideMenu: PropTypes.func,
  logOut: PropTypes.func,
  fullName: PropTypes.string,
};

const mapStateToProps = (state) => ({
  fullName: state.profile.fullName,
  accountSideMenu: state.accountSideMenu,
  userDivision: state.profile.division,
  userId: state.profile.userId,
  userEmail: state.profile.email,
  isAuthenticated: state.profile.isAuthenticated,
  token: (state.profile.generalSettings && state.profile.generalSettings.service_apiKey) || getSitecoreStateAuthToken(),
});

const mapDispatchToProps = (dispatch) => ({
  toggleAccountSideMenu: () => dispatch({ type: TOGGLE_ACCOUNT_SIDE_MENU }),
  toggleAccountSideMenuModal: () => dispatch({ type: TOGGLE_ACCOUNT_SIDE_MENU_ERROR_MODAL }),
  logOut: () => dispatch(logOut()),
  switchDivision: ({
    userId, divisionCode, token, isAuthenticated,
  }) =>
    dispatch(
      switchDivision({
        userId,
        divisionCode,
        token,
        onAfterSwitch: () => dispatch({ type: TOGGLE_ACCOUNT_SIDE_MENU }),
        onSwitchFail: () => dispatch({ type: TOGGLE_ACCOUNT_SIDE_MENU_ERROR_MODAL }),
        isAuthenticated,
      }),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSideMenu);

